import { render, staticRenderFns } from "./CustomerShowEdit.vue?vue&type=template&id=605209f0&lang=pug&"
import script from "./CustomerShowEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerShowEdit.vue?vue&type=script&lang=js&"
import style0 from "./CustomerShowEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerShowEdit.vue"
export default component.exports